"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    margin: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
}); });
exports.default = react_1.forwardRef(function Divider(_a, ref) {
    var _b;
    var className = _a.className, _c = _a.withMargin, withMargin = _c === void 0 ? false : _c, rest = __rest(_a, ["className", "withMargin"]);
    var classes = useStyles();
    return (jsx_runtime_1.jsx(Divider_1.default, __assign({ className: classnames_1.default(className, (_b = {},
            _b[classes.margin] = withMargin,
            _b)) }, rest, { ref: ref }), void 0));
});
//# sourceMappingURL=Divider.js.map